import { ReactElement } from 'react';

import { PromoProps } from './types';

import commonProps from '../../common/props';

export default function Promo(props: PromoProps): ReactElement {
  const { video, onEnded } = props;

  return (
    <video
      {...commonProps}
      onEnded={onEnded}
      style={{ objectFit: 'cover', display: 'block', margin: '0 auto' }}>
      <source src={video || ''} type='video/mp4' />
      <track kind='captions' />
    </video>
  );
}
